import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import LoginForm from '../containers/users/LoginForm'
import { useI18N } from '../../libraries/i18n/hook'
import SignupForm from '../containers/users/SignupForm'

const HeroSection = () => {
  return (
    <div className='flex justify-center md:mb-12 flex-col gap-8'>
      <div>
        <p className='hidden md:block text-xl md:mb-2 font-light'>
          CARRERAS PROFESIONALES
        </p>
        <p className='text-5xl md:text-7xl font-bold md:mb-4 text-deep-green md:tracking-wide leading-none font-astrid'>
          ACCEDE A LA MEJOR INFORMACIÓN SOBRE CARRERAS PROFESIONALES
        </p>
        <p className='hidden md:block text-md md:text-2xl text-black mb-4 text-deep-green'>
          Descubre <b>la plataforma nº 1 para universitarios</b> que quieren conocer cómo funciona realmente el mundo profesional y <b>acceder al mercado laboral con ventaja.</b>
        </p>
      </div>
    </div>
  )
}

const HeroVideo: React.FC<{ hideInMobile?: boolean, hideInDesktop?: boolean }> = ({ hideInMobile, hideInDesktop }) => (
  <div className={`w-[85vw] max-w-[415px] h-[48vw] md:h-80 md:h-full md:max-w-[60%] relative md:pt-[34%] rounded-lg overflow-hidden ${hideInMobile ? 'hidden md:block' : ''} ${hideInDesktop ? 'block md:hidden' : ''}`}>
    <iframe
      src='https://player.mediadelivery.net/embed/238409/33524ef5-081d-45bd-8516-d55944fd2928?autoplay=false&loop=false&muted=false&preload=true&responsive=true'
      loading='lazy'
      className='border-0 absolute top-0 h-full w-full'
      allow='accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;'
      allowFullScreen
    />
  </div>
)

const Login = () => {
  const { t } = useI18N()
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search)
  const tabParam = queryParams.get('tab')
  const [activeTab, setActiveTab] = React.useState(tabParam === 'signup' ? 'signup' : 'login')

  const handleTabChange = (tab: string) => {
    setActiveTab(tab)

    // Update URL query parameter
    const newParams = new URLSearchParams(location.search)
    if (tab === 'signup') {
      newParams.set('tab', 'signup')
    } else {
      newParams.delete('tab')
    }

    navigate({ search: newParams.toString() }, { replace: true })
  }

  return (
    <div className='min-h-screen flex items-center justify-center flex-col p-4'>
      <div className='text-center max-w-5xl'>
        <HeroSection />
      </div>
      <div className='w-full md:flex md:gap-20 max-w-6xl md:p-0'>
        <HeroVideo hideInMobile />
        <div className='w-full md:w-[40%] flex flex-col items-center mt-6 md:mt-0'>
          <div className='w-full max-w-md  bg-white rounded-lg shadow p-4'>
            <HeroVideo hideInDesktop />
            {/* Tab navigation */}
            <div className='p-2'>
              <div className='flex w-full my-6 border-b border-gray-200'>
                <button
                  onClick={() => handleTabChange('login')}
                  className={`w-1/2 py-2 text-center font-medium ${
                    activeTab === 'login'
                      ? 'text-deep-green border-b-2 border-deep-green'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {t('auth.login.signIn')}
                </button>
                <button
                  onClick={() => handleTabChange('signup')}
                  className={`w-1/2 py-2 text-center font-medium ${
                    activeTab === 'signup'
                      ? 'text-deep-green border-b-2 border-deep-green'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {t('auth.login.signUp')}
                </button>
              </div>

              {/* Tab content */}
              {activeTab === 'login' ? (
                <LoginForm />
              ) : (
                <SignupForm />
              )}
            </div>
          </div>

          {activeTab === 'login' && (
            <div className='text-center mt-4'>
              <p className='text-sm text-gray-600 mt-2'>
                {t('auth.login.needVerification')} {' '}
                <Link
                  to={'/verify-email'}
                  className='font-medium text-deep-green hover:text-gray-400'
                >
                  {t('auth.login.verifyEmail')}
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Login
